import { createTheme } from '@mui/material/styles';
import { colors, lightTheme, darkTheme, colorUtils } from './colors';

const getTheme = (mode) => {
    const themeColors = mode === 'light' ? lightTheme : darkTheme;

    return createTheme({
        breakpoints: {
            values: {
                xs: 0,      // Phone
                sm: 600,    // Tablet
                md: 960,    // Small laptop
                lg: 1280,   // Desktop
                xl: 1920,   // Large screens
            },
        },
        palette: {
            mode,
            primary: {
                main: colors.primary.main,
                light: colors.primary.light,
                dark: colors.primary.dark,
            },
            secondary: {
                main: colors.secondary.main,
                light: colors.secondary.light,
                dark: colors.secondary.dark,
            },
            accent: {
                main: colors.accent.main,
                light: colors.accent.light,
                dark: colors.accent.dark,
            },
            text: {
                primary: themeColors.text,
                secondary: mode === 'light' ? colors.primary.light : '#B2BEC3',
            },
            background: {
                default: themeColors.background,
                paper: mode === 'light'
                    ? 'rgba(255, 255, 255, 0.8)'
                    : 'rgba(45, 52, 54, 0.8)',
            },
        },
        typography: {
            fontFamily: '"Varela Round", "Roboto", "Helvetica", "Arial", sans-serif',
            h1: {
                fontWeight: 700,
                fontSize: 'clamp(2.5rem, 5vw, 3.5rem)',
                lineHeight: 1.2,
                letterSpacing: '-0.01562em',
            },
            h2: {
                fontWeight: 700,
                fontSize: 'clamp(2rem, 4vw, 3rem)',
                lineHeight: 1.2,
                letterSpacing: '-0.00833em',
            },
            h3: {
                fontWeight: 600,
                fontSize: 'clamp(1.75rem, 3vw, 2.5rem)',
                lineHeight: 1.2,
                letterSpacing: '0em',
            },
            h4: {
                fontWeight: 600,
                fontSize: 'clamp(1.5rem, 2.5vw, 2rem)',
                lineHeight: 1.2,
                letterSpacing: '0.00735em',
            },
            h5: {
                fontWeight: 600,
                fontSize: 'clamp(1.25rem, 2vw, 1.5rem)',
                lineHeight: 1.2,
                letterSpacing: '0em',
            },
            h6: {
                fontWeight: 600,
                fontSize: 'clamp(1.125rem, 1.5vw, 1.25rem)',
                lineHeight: 1.2,
                letterSpacing: '0.0075em',
            },
            subtitle1: {
                fontSize: 'clamp(1rem, 1.25vw, 1.125rem)',
                lineHeight: 1.5,
                letterSpacing: '0.00938em',
            },
            subtitle2: {
                fontSize: 'clamp(0.875rem, 1vw, 1rem)',
                lineHeight: 1.5,
                letterSpacing: '0.00714em',
                fontWeight: 500,
            },
            body1: {
                fontSize: 'clamp(1rem, 1.1vw, 1.125rem)',
                lineHeight: 1.5,
                letterSpacing: '0.00938em',
            },
            body2: {
                fontSize: 'clamp(0.875rem, 0.9vw, 1rem)',
                lineHeight: 1.5,
                letterSpacing: '0.01071em',
            },
        },
        components: {
            MuiContainer: {
                styleOverrides: {
                    root: {
                        paddingLeft: {
                            xs: 16,
                            sm: 24,
                            md: 32,
                        },
                        paddingRight: {
                            xs: 16,
                            sm: 24,
                            md: 32,
                        },
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        textTransform: 'none',
                        borderRadius: 8,
                        fontWeight: 500,
                        transition: 'all 0.3s ease-in-out',
                    },
                },
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        borderRadius: 12,
                        ...colorUtils.createGlassEffect(
                            mode === 'light' ? colors.background : colors.primary.main
                        ),
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        borderRadius: 12,
                        backgroundImage: 'none',
                    },
                },
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        '& .MuiOutlinedInput-root': {
                            borderRadius: 8,
                        },
                    },
                },
            },
        },
        shape: {
            borderRadius: 8,
        },
    });
};

export { getTheme };
